<div class="validation-errors p-t-md p-b-md">
  <ng-container *ngFor="let errorGroup of errorForm.fieldGroups">
    <ng-container *ngIf="errorGroup.fields && errorGroup.fields.length > 0">
      <plyca-validation-group [errorGroup]="errorGroup"></plyca-validation-group>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="errorForm.unmappedErrors?.length > 0">
    <plyca-validation-group [unmapedErrors]="errorForm.unmappedErrors"></plyca-validation-group>
  </ng-container>
</div>